import { TransitionTokenValue } from 'designSystem/types';
import * as S from './styles';

interface TransitionTokenPreviewProps {
	value: TransitionTokenValue;
}

export const TransitionTokenPreview = ({ value }: TransitionTokenPreviewProps) => {
	return (
		<S.PreviewContainer>
			<S.TransitionBox duration={value.duration} timingFunction={value.timingFunction} />
		</S.PreviewContainer>
	);
};
